module.exports = function getResource(label, vars = []) {
    let resources = {
        share: 'Share',
        copied: 'Copied',
        copy: 'Copy'
    };
    return resources[label];
};
